import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculateTotals, cuFormat } from "../../../../components/table/coreUiTable/Format";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

export const ContactLogsTable = () => {
  let [filteredData, setFilteredData] = useState([]);
  let [totalsForExport, setTotalsForExport] = useState([]);
  let [totalSlots, setTotalSlots] = useState([]);

  const {
    tableInfo: {
      data = [],
      totals = [],
      colHeaders = [],
      columns = [],
      links = [],
      rowCalculations = []
    }
  } = useSelector((state) => state.activities.chartsData?.tableData?.content);

  const showTotals = totals && totals.length && filteredData.length > 1;

  const onFilteredItemsChange = (data) => {
    setFilteredData(data);
  };

  const formattedSlots = cuFormat({
    countTitle: "#",
    headers: colHeaders,
    columns: columns,
    links: links
  });

  useEffect(() => {
    if (!showTotals) return;
    let totals = ["Total"];

    const totalRow = colHeaders.slice(1).map((header, index) => {
      const renderFunc = formattedSlots[header];
      const calculatedValue = calculateTotals(
        filteredData,
        rowCalculations[index + 1],
        colHeaders,
        header
      );
      const value = {
        [header]: calculatedValue
      };

      totals.push(calculatedValue);

      return renderFunc(value, {});
    });

    setTotalSlots(totalRow);
    setTotalsForExport(totals);
  }, [filteredData]);

  return (
    <TableWithCustomSearch
      table={{ data, colHeaders }}
      data={data}
      colHeaders={colHeaders}
      columns={columns}
      fileName="activities"
      links={links}
      onFilteredItemsChange={onFilteredItemsChange}
      additionalDataToExport={totalsForExport}
      scopedSlots={formattedSlots}
      footerSlot={
        showTotals ? (
          <tfoot>
            <tr className="">
              <td></td>
              <td>Total</td>
              {totalSlots}
            </tr>
          </tfoot>
        ) : null
      }
      sorter
      title=" "
      showCount
      hideFirstCol
    />
  );
};
